// extracted by mini-css-extract-plugin
export default {"home__container":"Home_home__container__rMdSt","home__textWrapper":"Home_home__textWrapper__qLhrR","home__text":"Home_home__text__cch-4"};